@if (form) {
  <div class="form" [formGroup]="form">
    <div class="flex flex-column gap-2 mb-3">
      <label for="resolutionNote"> {{ "security_tool.resolve_form.resolution_note" | translate }}* </label>
      <textarea pInputTextarea id="resolutionNote" formControlName="resolutionNote"></textarea>
    </div>
    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
      <app-button buttonText="common.send" [disabled]="!form.valid" (click)="resolveAlert()"> </app-button>
    </div>
  </div>
}
